import { DiscoveryInput, EvaluationTask, Scalars } from 'generated/graphql'

import { CriteriaDrawerContent } from './CriteriaDrawerContent'

export interface Props {
  task: EvaluationTask
  editDiscovery: (discoveryInput: DiscoveryInput) => Promise<boolean>
  deleteDiscovery: (discoveryId: Scalars['ID']) => Promise<boolean>
}

const CriteriaDrawer = ({
  task,
  editDiscovery,
  deleteDiscovery,
}: Props): JSX.Element => {
  return (
    <CriteriaDrawerContent
      task={task}
      onEditDiscovery={editDiscovery}
      onDeleteDiscovery={deleteDiscovery}
    />
  )
}

export { CriteriaDrawer }
